import { gate } from 'hub-http/gates';
import { PERSONALIZATION_TOKEN } from '../editorCapabilities/constants';
export const PERSONALIZATION_TOKENS_P2 = gate('CommPlatform:TeamSignature:ShowInCRM');
export function personalizationTokenStylesToString(tokenStyles) {
  return Object.keys(tokenStyles).map(key => `${key}: ${tokenStyles[key]}`).join('; ') || undefined;
}
export function personalizationTokenStylesFromString(tokenStylesStr) {
  const tokenStyles = {};
  tokenStylesStr === null || tokenStylesStr === void 0 || tokenStylesStr.split(';').forEach(styleStr => {
    const [__, key, value] = styleStr.match(/(margin|padding|fontColor|borderColor|backgroundColor|tokenIconKey): ([\w\-#()\s]+)/) || [];
    if (key) tokenStyles[key] = value;
  });
  return tokenStyles;
}
export function formatPersonalizationToken(tokenKey, defaultTokenValue) {
  if (defaultTokenValue) {
    return `{{ ${tokenKey}|default('${defaultTokenValue}') }}`;
  }
  return `{{ ${tokenKey} }}`;
}
export function parseDefaultValueFromDOM(tokenKey, el) {
  if (!tokenKey) return null;
  const tokenText = el.textContent || '';
  const defaultStart = tokenText.indexOf("|default('");
  if (defaultStart === -1) return null;
  const valueStart = defaultStart + "|default('".length;
  const valueEnd = tokenText.indexOf("')", valueStart);
  if (valueEnd === -1) return null;
  return tokenText.substring(valueStart, valueEnd);
}
export const formatDisplayText = tokenKey => {
  return tokenKey.replace(/\./g, ':').replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
};
export function getTokenTooltip(editorConfig, tokenKey) {
  var _tokensConfig$tokenTo;
  const tokensConfig = editorConfig === null || editorConfig === void 0 ? void 0 : editorConfig[PERSONALIZATION_TOKEN];
  return (tokensConfig === null || tokensConfig === void 0 || (_tokensConfig$tokenTo = tokensConfig.tokenTooltips) === null || _tokensConfig$tokenTo === void 0 ? void 0 : _tokensConfig$tokenTo[tokenKey]) || null;
}